export const SET_THEME = "SET_THEME";
export const SET_LOGO = "SET_LOGO";
export const SET_CLIENT_IDS = "SET_CLIENT_IDS";
export const SET_LINKS = "SET_LINKS";
export const GET_THEME = "GET_THEME";
export const GET_LOGO = "GET_LOGO";
export const GET_CLIENT_IDS = "GET_CLIENT_IDS";
export const GET_LINKS = "GET_LINKS";
export const SET_ANALYTICS = "SET_ANALYTICS";
export const GET_ANALYTICS = "GET_ANALYTICS";
